<template>
  <div
      class="sm:hidden relative object-fill bg-slate-100 select-none max-h-[160px] sm:max-h-[331px] h-[28vh] md:h-[33vh] lg:h-[36vh] min-h-[50px]">
    <!-- Loader -->
    <div v-if="isImageLoading" class="absolute inset-0 flex justify-center items-center bg-gray-100">
      <div class="lds-dual-ring"></div>
    </div>
    <NuxtImg
        :alt="imageName"
        :draggable="false"
        :src="imageURL || defaultImg"
        :srcset="generateSrcSet(imageURL)"
        :loading="index === 0 ? 'eager' : 'lazy'"
        sizes="(max-width: 640px) 100vw, 640px"
        :width="640"
        class="w-full h-full block lazyload"
        @error="handleImgError"
        @load="stopImageLoading"
        placeholder="blur"
    />
  </div>
</template>

<script>
import defaultImg from "@/assets/images/placeholder_doNotRemove_.webp";

export default {
  data() {
    return {
      isImageLoading: true,
      defaultImg,
    };
  },
  props: {
    imageURL: {
      type: String,
      required: true,
      default: "",
    },
    imageName: {
      type: String,
      required: true,
      default: "",
    },
    index: {
      type: Number,
      required: true,
    },
  },
  mounted() {
    // Preload the first image for faster LCP
    if (this.index === 0 && this.imageURL) {
      const link = document.createElement("link");
      link.rel = "preload";
      link.as = "image";
      link.href = this.imageURL;
      document.head.appendChild(link);
    }
  },
  methods: {
    stopImageLoading() {
      this.isImageLoading = false;
    },
    handleImgError(e) {
      if (!e.target.src.includes(this.defaultImg)) {
        // Replace the image source with the default placeholder on error
        this.stopImageLoading();
        e.target.src = this.defaultImg;
        e.onerror = null; // Prevent infinite loops
      }
    },
    generateSrcSet(imageURL) {
      // Generate responsive image URLs for `srcset`
      if (!imageURL) return this.defaultImg;
      return `
        ${imageURL}?w=320 320w,
        ${imageURL}?w=640 640w,
        ${imageURL}?w=960 960w,
        ${imageURL}?w=1280 1280w
      `;
    },
  },
};
</script>

<style scoped>
/* Critical loader styles */
.lds-dual-ring {
  display: inline-block;
  width: 64px;
  height: 64px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 46px;
  height: 46px;
  margin: 1px;
  border-radius: 50%;
  border: 5px solid #ccc;
  border-color: #ccc transparent #ccc transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
